import styled from 'styled-components';
import BottomModal from '../../../components/modal/BottomModal';

interface Props {
  onClose: () => void;
}

const list = [
  {
    title: '1개월 무료 이용권',
    titleDesc: '스탠다드 전국구',
    desc: '럭키 이벤트 쿠폰',
  },
  {
    title: '50% 할인 쿠폰',
    titleDesc: '스탠다드 전국구',
    desc: '럭키 이벤트 쿠폰',
  },
  {
    title: '1,000원 할인 쿠폰',
    titleDesc: '1만 원 이상 상품 구매 시',
    desc: '럭키 이벤트 쿠폰',
  },
  {
    title: '3,000원 할인 쿠폰',
    titleDesc: '5만 원 이상 상품 구매 시',
    desc: '럭키 이벤트 쿠폰',
  },
  {
    title: '5,000원 할인 쿠폰',
    titleDesc: '10만 원 이상 상품 구매 시',
    desc: '럭키 이벤트 쿠폰',
  },
  {
    title: '10,000원 할인 쿠폰',
    titleDesc: '30만 원 이상 상품 구매 시',
    desc: '럭키 이벤트 쿠폰',
  },
  {
    title: '3일 무료 이용권',
    titleDesc: '수도권',
    desc: '럭키 이벤트 쿠폰',
  },
];

function CouponListModal({ onClose }: Props) {
  return (
    <BottomModal onClose={onClose}>
      <Header>
        <CloseButton onClick={onClose}>
          <img src="/assets/images/close/close-black24.svg" alt="" />
        </CloseButton>
      </Header>
      <Inner>
        <Title>랜덤 쿠폰 리스트</Title>
        <CouponList>
          {list.map((c) => (
            <Coupon>
              <CouponImg src="/assets/images/promotion/lucky/coupon.png" />
              <CouponInner>
                <CouponTitle>
                  {c.title}
                  <CouponTitleDesc>{c.titleDesc}</CouponTitleDesc>
                </CouponTitle>
                <CouponDesc>{c.desc}</CouponDesc>
              </CouponInner>
            </Coupon>
          ))}
        </CouponList>
      </Inner>
      <Bottom>
        <ConfirmButton onClick={onClose}>확인</ConfirmButton>
      </Bottom>
    </BottomModal>
  );
}

export default CouponListModal;

const Header = styled.div`
  display: flex;
  width: 360px;
  padding: 24px 20px 0 20px;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  width: 100%;
`;

const CloseButton = styled.button`
  border: none;
  outline: none;
  cursor: pointer;

  display: flex;
  width: 40px;
  height: 40px;
  justify-content: center;
  align-items: center;
  border-radius: 999px;
  background: #f2f2f2;

  & > img {
    width: 20px;
    height: 20px;
  }
`;

const Inner = styled.div`
  display: flex;
  height: 488px;
  padding: 0 20px;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
  overflow-y: auto;
`;

const Title = styled.div`
  align-self: stretch;

  color: #222;
  text-align: center;
  font-family: Paperlogy;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 140%; /* 33.6px */
`;

const CouponList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
`;

const Coupon = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  aspect-ratio: 312 / 134;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
`;

const CouponImg = styled.img`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
`;

const CouponInner = styled.div`
  position: absolute;
  left: 32px;
  top: 27.5px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  z-index: 10;
`;

const CouponTitle = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  color: #000;
  font-family: 'Wanted Sans';
  font-size: 20px;
  font-style: normal;
  font-weight: 900;
  line-height: 130%; /* 26px */
`;

const CouponTitleDesc = styled.div`
  color: #000;
  font-family: 'Wanted Sans';
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%; /* 19.5px */
`;

const CouponDesc = styled.div`
  color: #565b56;
  text-align: center;
  font-family: 'Wanted Sans';
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%; /* 18.2px */
`;

const Bottom = styled.div`
  display: flex;
  padding: 24px 20px;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  align-self: stretch;
`;

const ConfirmButton = styled.button`
  border: none;
  outline: none;
  cursor: pointer;
  display: flex;
  padding: 16px 24px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  border-radius: 16px;
  background: #222;
  color: #fff;
  text-align: center;
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 140%; /* 22.4px */
  letter-spacing: -0.64px;
`;
